import React from 'react';
import { useTheme } from '@mui/material';

const PrevWave = () => {
  const theme = useTheme();

  return (
    <svg width="24" height="12" viewBox="0 0 24 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0325 5.21949C12.6851 5.409 12.6851 5.90788 13.0325 6.09738L22.4884 11.2551C22.8215 11.4369 23.2278 11.1957 23.2278 10.8162V0.500707C23.2278 0.121177 22.8215 -0.11998 22.4884 0.0617586L13.0325 5.21949ZM1.03255 5.21949C0.685115 5.409 0.685115 5.90788 1.03255 6.09739L10.4884 11.2551C10.8216 11.4369 11.2278 11.1957 11.2278 10.8162L11.2278 0.500711C11.2278 0.121182 10.8216 -0.119975 10.4884 0.0617633L1.03255 5.21949Z"
        fill={theme.palette.text.extraLight}
      />
    </svg>
  );
};

export default PrevWave;
